import { render, staticRenderFns } from "./modal-card-resumo-propostas.vue?vue&type=template&id=db9d7664"
import script from "./modal-card-resumo-propostas.vue?vue&type=script&lang=js"
export * from "./modal-card-resumo-propostas.vue?vue&type=script&lang=js"
import style0 from "./modal-card-resumo-propostas.vue?vue&type=style&index=0&id=db9d7664&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports